import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        borderBottom: `1px solid ${theme.brand.border}`,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    inputs: {
        padding: `8px 16px`,
        borderRight: `1px solid ${theme.brand.border}`,
        [theme.breakpoints.down('sm')]: {
            borderBottom: `1px solid ${theme.brand.border}`,
            borderRight: 'none',
        },
    },
    balance: {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(2),
    },
    stat: {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('sm')]: {
            paddingTop: 8,
            paddingBottom: 8,
        },
    },
    borderRight: {
        borderRight: `1px solid ${theme.brand.border}`,
    },
    borderBottom: {
        borderBottom: `1px solid ${theme.brand.border}`,
    },
    bonusText: {
        fontWeight: 500,
        verticalAlign: 'top',
        color: theme.brand.JavaGreen,
    },
    logoSwitcher: {
        marginBottom: 8,
    },
    stakeFooter: {
        padding: 16,
    },
    summarySub: {
        fontWeight: 200,
        fontSize: '0.8rem',

        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
    },
    textboxSpacer: {
        margin: 16,
    },
}));

export default useStyles;
